module.exports = __webpack_public_path__ + "static/media/cq_firma_documento_blu_scuro.202c8ef4.svg";